import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { updateServiceControll } from "../../../../services/ServiceControllService";
import { toast } from "react-toastify";
import Select from "react-select";
import { findByLicensePlate } from "../../../../services/CarService";
import currencyBRFormat from "../../../../util/CurrencyUtils";
import carBrands from "../../../../consts/CarBrands";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Spinner from "../../../../components/Spinner";
import CadastrarServicoModal from "./CadastrarServicoModal";
import CadastrarClienteVeiculoModal from "./CadastrarClienteVeiculoModal";

export const EditarControleServico = (props) => {
  const [selectedServices, setSelectedServices] = useState(
    props.serviceControll.services.map((service) => ({
      value: service.id,
      label: service.name,
      key: service.price,
    }))
  );
  const [selectedCustomer, setSelectedCustomer] = useState(
    props.customers.find((c) => c.value == props.serviceControll.customerId)
  );
  const [selectedEmployee, setSelectedEmployee] = useState(
    props.employees.find((e) => e.label == props.serviceControll.employeeName)
  );
  const inputLicensePlate = useRef("");
  const inputVehicleBrand = useRef("");
  const inputVehicleColor = useRef("");
  const inputVehicleModel = useRef("");
  const inputSelectCustomer = useRef();
  const inputSignValue = useRef("");
  const inputCheckList = useRef("");
  const [isOpen, setIsOpen] = useState(false);
  const [searchingCar, setSearchingCar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalServicoOpen, setModalServicoOpen] = useState(false);
  const [modalCadastroCliente, setModalCadastroCliente] = useState(false);
  const [vehicleBrand, setVehicleBrand] = useState({
    label: carBrands.find((b) => b == props.serviceControll.car.brand),
  });

  useEffect(() => {
    setIsOpen(props.openEditModal);
  }, [props]);

  const toggle = () => {
    props.setOpenEditModal(false);
  };

  function handleInputLicensePlate(e) {
    e.preventDefault();
    setSearchingCar(true);
    if (e.target.value) {
      findByLicensePlate(e.target.value)
        .then((response) => {
          setSearchingCar(false);
          if (response) {
            inputLicensePlate.current.value = e.target.value;
            inputVehicleColor.current.value = response.color;
            inputVehicleModel.current.value = response.model;
            setVehicleBrand({
              key: response.brand,
              label: response.brand,
              value: response.brand,
            });
          }
        })
        .catch((error) => {
          console.error(error);
          setSearchingCar(false);
        });
    } else {
      setSearchingCar(false);
    }
  }

  const formatServicesLabels = (service) => (
    <>
      <span>{service.label}</span>
      <span> - R$ {service.key}</span>
    </>
  );

  const formatCustomersLabels = (customer) => (
    <>
      <span>{customer.key}</span>
      <span>{customer.label}</span>
    </>
  );

  function handleSubmit(e) {
    e.preventDefault();

    const data = {
      id: props.serviceControll.id,
      licensePlate: inputLicensePlate.current.value,
      vehicleBrand: inputVehicleBrand.current.value,
      vehicleColor: inputVehicleColor.current.value,
      vehicleModel: inputVehicleModel.current.value,
      servicesIds: selectedServices.map((service) => service.value),
      userId: localStorage.getItem("userId"),
      employeeId: selectedEmployee.value,
      customerId: selectedCustomer ? selectedCustomer.value : null,
      signValue: inputSignValue.current.value ?? 0,
      checklist: inputCheckList.current.value,
    };

    updateServiceControll(data)
      .then((response) => {
        props.listControllServices();
        toast.success("Ordem de Serviço atualizada");
        props.setOpenEditModal(false);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Não foi editar esta ordem de serviço");
      });
  }

  function calculateTotalSelectServices() {
    return currencyBRFormat(
      selectedServices
        ? selectedServices
          .map((service) => service.key)
          .reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
        : 0
    );
  }

  return (
    <div>
      <CadastrarServicoModal
        setModalServicoOpen={setModalServicoOpen}
        modalServicoOpen={modalServicoOpen}
        listServices={props.listServices}
      />

      <CadastrarClienteVeiculoModal
        setModalCadastroCliente={setModalCadastroCliente}
        open={modalCadastroCliente}
        listCustomers={props.listCustomers}
      />

      <Modal
        isOpen={isOpen}
        backdrop="static"
        size="lg"
        centered
        contentClassName="border-0 rounded-4 shadow-lg"
      >
        <ModalHeader className="no-select border-bottom-0 pb-0 pt-4 px-4" toggle={toggle}>
          <span className="fw-bold text-dark">Editar Ordem de Serviço</span>
        </ModalHeader>

        <form onSubmit={handleSubmit}>
          <ModalBody className="p-4">
            {/* SEÇÃO 1: VEÍCULO (IGUAL AO NOVO) */}
            <div className="bg-light p-3 rounded-4 border mb-4">
              <div className="d-flex align-items-center mb-3">
                <i className="fas fa-car me-2 text-primary"></i>
                <span className="fw-bold text-muted small text-uppercase">Dados do Veículo</span>
              </div>

              {searchingCar ? (
                <div className="text-center py-3"><Spinner /></div>
              ) : (
                <div className="row g-3">
                  <div className="col-lg-3">
                    <label className="form-label small fw-bold text-dark">Placa <span className="text-danger">*</span></label>
                    <input
                      onBlur={handleInputLicensePlate}
                      ref={inputLicensePlate}
                      defaultValue={props.serviceControll.car.licensePlate}
                      type="text"
                      minLength={7}
                      maxLength={7}
                      className="form-control form-control-lg fw-bold text-uppercase border-2"
                      style={{ letterSpacing: '2px', backgroundColor: '#fff' }}
                      required
                    />
                  </div>
                  <div className="col-lg-3">
                    <label className="form-label small fw-bold text-dark">Marca <span className="text-danger">*</span></label>
                    <Select
                      name="brands"
                      classNamePrefix="select"
                      onChange={(brand) => setVehicleBrand(brand)}
                      value={vehicleBrand}
                      options={carBrands.map((brand) => ({
                        value: brand.replace("_", " "),
                        key: brand,
                        label: brand.replace("_", " "),
                      }))}
                      placeholder="Marca..."
                      isDisabled={true}
                      required
                      styles={{ control: (b) => ({ ...b, borderRadius: '8px', minHeight: '48px', backgroundColor: '#e9ecef' }) }}
                    />
                  </div>
                  <div className="col-lg-3">
                    <label htmlFor="modeloCarro" className="form-label small fw-bold text-dark">Modelo <span className="text-danger">*</span></label>
                    <input
                      ref={inputVehicleModel}
                      defaultValue={props.serviceControll.car.model}
                      id="modeloCarro"
                      className="form-control form-control-lg fs-6"
                      disabled={true}
                      required
                    />
                  </div>
                  <div className="col-lg-3">
                    <label htmlFor="corCarro" className="form-label small fw-bold text-dark">Cor</label>
                    <input
                      id="corCarro"
                      ref={inputVehicleColor}
                      defaultValue={props.serviceControll.car.color}
                      className="form-control form-control-lg fs-6"
                      disabled={true}
                      placeholder="Preto..."
                    />
                  </div>
                </div>
              )}
            </div>

            {/* SEÇÃO 2: CLIENTE E RESPONSÁVEL (IGUAL AO NOVO) */}
            <div className="row mb-4 g-3">
              <div className="col-lg-7">
                <div className="h-100 bg-white p-3 rounded-4 border shadow-sm">
                  <label className="form-label fw-bold text-muted small text-uppercase mb-2">
                    <i className="fas fa-user me-2"></i>Cliente
                  </label>
                  <Select
                    ref={inputSelectCustomer}
                    onChange={(customer) => setSelectedCustomer(customer)}
                    id="customerSelect"
                    name="customers"
                    classNamePrefix="select"
                    value={selectedCustomer}
                    options={props.customers}
                    placeholder="Vincular a um cliente..."
                    formatOptionLabel={formatCustomersLabels}
                    isClearable
                    styles={{ control: (b) => ({ ...b, borderRadius: '8px' }) }}
                  />
                </div>
              </div>
              <div className="col-lg-5">
                <div className="h-100 bg-white p-3 rounded-4 border shadow-sm">
                  <label className="form-label fw-bold text-muted small text-uppercase mb-2">
                    <i className="fas fa-id-badge me-2"></i>Funcionário
                  </label>
                  <Select
                    onChange={(data) => setSelectedEmployee(data)}
                    id="listaUsuarios"
                    name="services"
                    classNamePrefix="select"
                    value={selectedEmployee}
                    options={props.employees}
                    placeholder="Responsável..."
                    required
                    styles={{ control: (b) => ({ ...b, borderRadius: '8px' }) }}
                  />
                </div>
              </div>
            </div>

            {/* SEÇÃO 3: CHECKLIST E SERVIÇOS (IGUAL AO NOVO) */}
            <div className="bg-light p-3 rounded-4 border mb-3">
              <div className="row g-4">
                <div className="col-lg-12">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <label className="form-label fw-bold text-muted small text-uppercase mb-0">Checklist</label>
                    <button
                      onClick={() => (inputCheckList.current.value = "Veículo sem avarias ou detalhes")}
                      className="btn btn-sm btn-success rounded-pill px-3 fw-bold"
                      type="button"
                      style={{ fontSize: "0.75rem" }}
                    >
                      <i className="fas fa-check me-1"></i> Sem Avarias
                    </button>
                  </div>
                  <textarea
                    ref={inputCheckList}
                    defaultValue={props.serviceControll.checklist}
                    className="form-control rounded-3 border-2"
                    rows="2"
                    placeholder="Ex: Risco na porta esquerda..."
                    required
                  />
                </div>

                <div className="col-lg-12">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <label className="form-label fw-bold text-muted small text-uppercase mb-0">Serviços a Realizar</label>
                    <button
                      onClick={() => setModalServicoOpen(true)}
                      type="button"
                      className="btn btn-sm btn-primary rounded-pill px-3 fw-bold"
                      style={{ fontSize: "0.75rem" }}
                    >
                      <i className="fas fa-plus me-1"></i> Novo Serviço
                    </button>
                  </div>
                  <Select
                    onChange={(data) => setSelectedServices(data)}
                    id="listaServicos"
                    isMulti
                    name="services"
                    classNamePrefix="select"
                    options={props.services}
                    value={selectedServices}
                    formatOptionLabel={formatServicesLabels}
                    placeholder="Selecione os serviços..."
                    isClearable
                    required
                    styles={{ control: (b) => ({ ...b, borderRadius: '8px' }) }}
                  />
                  <div className="text-end mt-2">
                    <span className="text-muted small fw-bold text-uppercase me-2">Total:</span>
                    <span className="h5 fw-bold text-primary mb-0">{calculateTotalSelectServices()}</span>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>

          {/* FOOTER PADRÃO ALCON AUTO (RESPONSIVO) */}
          <ModalFooter className="border-top-0 p-4 pt-0">
            {!loading ? (
              <div className="d-flex flex-column flex-sm-row w-100 gap-2">
                <button
                  type="submit"
                  className="btn btn-primary btn-lg fw-bold flex-grow-1 rounded-3 shadow-sm order-0"
                >
                  <i className="fas fa-save me-2"></i>
                  Salvar Alterações
                </button>

                <button
                  type="button"
                  onClick={toggle}
                  className="btn btn-outline-danger btn-lg rounded-3 border-2 order-1"
                >
                  Cancelar
                </button>
              </div>
            ) : (
              <div className="w-100 text-center py-2">
                <Spinner color="primary" />
              </div>
            )}
          </ModalFooter>
        </form>
      </Modal>
    </div>
  );
};

export default EditarControleServico;
